export function formatCount(count: number | undefined | null): string {
  if (count === undefined || count === null) return '';
  return count.toLocaleString('en-US');
}
